import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../apis-keys"
import {
	IPropsGetGuestManagementClassification,
	IResponseGetGuestManagementClassification,
} from "./types"
import { GuestManagementClassificationUrl } from "../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../useApi"

async function getGuestManagementClassification(
	apiPrivate: AxiosInstance,
	{ ...rest }: IPropsGetGuestManagementClassification
) {
	try {
		const response: AxiosResponse<IResponseGetGuestManagementClassification> =
			await apiPrivate.get(`${GuestManagementClassificationUrl}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetGuestManagementClassification(
	data: IPropsGetGuestManagementClassification,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetGuestManagementClassification,
					unknown,
					IResponseGetGuestManagementClassification
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETCLASSIFICATION, ...Object.values(data)],
		queryFn: () => getGuestManagementClassification(apiPrivate, data),
		...options,
	})
}
